<template>
  <div class="main">
    <my-breadcrumb>视频教程</my-breadcrumb>
    <MainCard ref="MainCard" :dataResource="dataResource" />
  </div>
</template>

<script>
import MyBreadcrumb from '@/components/my-breadcrumb.vue'
import MainCard from '@/components/MainCard.vue'
export default {
  name: 'Movies',
  components: {
    MyBreadcrumb,
    MainCard
  },
  data() {
    return {
      dataResource: ['movies', '3-1']
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/index.less';
</style>
